import { render, staticRenderFns } from "./TrimmingDialog.vue?vue&type=template&id=bda3c97e&scoped=true&"
import script from "./TrimmingDialog.vue?vue&type=script&lang=ts&"
export * from "./TrimmingDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TrimmingDialog.vue?vue&type=style&index=0&id=bda3c97e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda3c97e",
  null
  
)

export default component.exports